function mergeFieldToLowerCase(text) {
    if (!text) return text;
    if (typeof text !== 'string') return text.toString();

    const replacer = match => match.toLowerCase();

    // FIXME: Regex is not nunjucks, this will cause leaks/unexpected behaviour
    // This is also incompatible with PCG cascading risk, it is case-sensitive
    // https://groups.google.com/forum/#!topic/nunjucks/7zHMk5lmyZs
    const nt = text.replace(/{%\s*.+?\s*%}/g, replacer);
    return nt.replace(/{{\s*[\w.]+\s*}}/g, replacer);
}

export default mergeFieldToLowerCase;



// WEBPACK FOOTER //
// ./src/lib/util.js